import React from 'react'
import './index.scss'
import AutoPlayVideo from '../AutoPlayVideo'
import ReactHtmlParser from 'react-html-parser'

interface PointItemProps {
  title: string
  subtitle: string
  subtitle_2?: string
  subtitle_3?: string
  imageUrl?: string
  videoUrl?: string
  number: number
}

const PointItem: React.FC<PointItemProps> = ({ title, subtitle, subtitle_2, subtitle_3, imageUrl, videoUrl, number }) => {
  return (
    <div className='point-background'>
        <div className="point-badge">
            <div className="point-label">POINT</div>
            <div className="point-number">{number}</div>
        </div>
        <div className="title-point">{ReactHtmlParser(title)}</div>
        <div className="subtitle-point">{subtitle}</div>
        {subtitle_2 && <div className="subtitle-point">{subtitle_2}</div>}
        {subtitle_3 && <div className="subtitle-point">{subtitle_3}</div>}
        <div className="img-or-video">
            {videoUrl ? (
                <AutoPlayVideo src={videoUrl} />
            ) : (
                <img src={imageUrl} alt={`feature-${number}`} loading="lazy" decoding="async" />
            )}
        </div>
    </div>
  )
}

export default PointItem